import { Link, Navigate, useParams } from "react-router";
import { ArrowRight } from "lucide-react";
import { getCategory, productsByCategory } from "../data/products";
import ProductCard from "../components/ProductCard";
import { categorySeo, notFoundSeo } from "../data/seo";
import { useSeo } from "../hooks/useSeo";

export default function Category() {
  const { slug = "" } = useParams();
  const category = getCategory(slug);
  const products = productsByCategory(slug);

  useSeo(category ? categorySeo(category) : notFoundSeo);

  if (!category) return <Navigate to="/shop" replace />;

  return (
    <div className="mx-auto max-w-7xl px-4 py-10 sm:py-14">
      <nav className="text-sm text-muted-foreground" aria-label="Breadcrumb">
        <Link to="/" className="hover:text-primary">
          Home
        </Link>{" "}
        /{" "}
        <Link to="/shop" className="hover:text-primary">
          Peptides
        </Link>{" "}
        / <span className="text-foreground">{category.name}</span>
      </nav>

      <div className="mt-8 max-w-3xl">
        <p className="text-xs font-semibold uppercase tracking-wider text-primary">
          Research peptide category
        </p>
        <h1 className="mt-2 text-3xl font-extrabold tracking-tight sm:text-4xl">
          {category.name}
        </h1>
        <p className="mt-3 text-lg leading-relaxed text-muted-foreground">
          {category.tagline}
        </p>
        <p className="mt-5 leading-relaxed text-muted-foreground">
          {category.description}
        </p>
      </div>

      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {products.map((product, i) => (
          <ProductCard key={product.slug} product={product} eager={i < 2} />
        ))}
      </div>

      <section
        className="mt-14 rounded-2xl bg-secondary p-8"
        aria-labelledby="category-coa"
      >
        <h2 id="category-coa" className="text-xl font-extrabold">
          Verify the Current Batch Before Ordering
        </h2>
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-muted-foreground">
          Ask for the current Certificate of Analysis for any product in this
          category before you buy. Check the batch number, HPLC purity, mass
          spectrometry identity and handling notes against your protocol.
        </p>
        <Link
          to="/contact"
          className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-primary hover:underline"
        >
          Request a category COA{" "}
          <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      </section>
    </div>
  );
}
